import { FC, SVGProps } from 'react'

export const Loop: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="16" y="5.33331" width="12" height="5.33333" fill="currentColor" />
    <rect x="4" y="10.6667" width="12" height="5.33333" fill="currentColor" />
    <rect x="16" y="16" width="12" height="5.33333" fill="currentColor" />
    <rect x="4" y="21.3333" width="12" height="5.33333" fill="currentColor" />
  </svg>
)
